import {parseCalendarActivityTarget} from '../../../../supabase/functions/_shared/fluCalendarNavigation';
import {parentFluAction} from '../../../../supabase/functions/_shared/fluScreenContext';
/** Fixed read-only destinations. Neither model text nor tool output may supply arbitrary URLs. */
const uuid=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const fluSectionPaths:Record<string,string>={
 'open-pipeline-settings':'/settings?tab=lead-pipelines','open-dashboard':'/dashboard',
 'open-activities':'/calendar','open-offers':'/deals','open-newsletter':'/newsletter',
 'open-team-settings':'/settings?tab=users'
};
export function fluProjectPath(id:unknown){return typeof id==='string'&&uuid.test(id)?'/projects/'+id:null;}
export function fluRecordPath(id:unknown){return typeof id==='string'&&uuid.test(id)?'/leads/'+id:null;}
export function fluProposalPath(items:Array<{status:string;tool_name:string;arguments:Record<string,unknown>;executable?:boolean;record_ref?:unknown}>){
 const pending=items.filter(p=>p.status==='pending'&&p.executable!==false);
 if(pending.length!==1)return null;
 const p=pending[0];
 if(['crm_projects_assign_user','crm_tasks_create','crm_tasks_complete'].includes(p.tool_name)){
  const ref=p.record_ref as {entity?:unknown;id?:unknown}|null;
  if(!ref||typeof ref!=='object'||Array.isArray(ref)||Object.keys(ref).sort().join(',')!=='entity,id'||ref.entity!=='project')return null;
  const path=fluProjectPath(ref.id);return path&&path===fluProjectPath(p.arguments.project_id)?path:null;
 }
 if(p.tool_name==='crm_onboarding_pipeline_create')return '/settings?tab=lead-pipelines';
 if(p.tool_name==='crm_clients_create_lead')return '/leads';
 if(!['crm_clients_update','crm_clients_note_create','crm_activities_create','crm_activities_update'].includes(p.tool_name))return null;
 if(p.record_ref!=null){
  const ref=p.record_ref as {entity?:unknown;id?:unknown};
  if(typeof ref!=='object'||Array.isArray(ref)||Object.keys(ref).sort().join(',')!=='entity,id'||ref.entity!=='client')return null;
  const path=fluRecordPath(ref.id);if(!path)return null;
  const declared=p.arguments.client_id||p.arguments.lead_id;
  if(declared&&fluRecordPath(declared)!==path)return null;
  return path;
 }
 return fluRecordPath(p.arguments.client_id||p.arguments.lead_id);
}
export function mayFollowFlu(enabled:boolean,sameView:boolean,editing:boolean){return enabled&&sameView&&!editing;}

/** An open CRM form is protected even before the first keystroke. Editors may
 * replace their DOM nodes, so a remembered input alone is not a reliable guard. */
export function hasOpenCrmForm(root:ParentNode):boolean{
 return Array.from(root.querySelectorAll<HTMLFormElement>('form')).some(form=>
  !form.closest('.goal-consultant,[hidden],[inert],[aria-hidden="true"]')&&
  form.getClientRects().length>0&&
  !!form.querySelector('input:not([type="hidden"]),textarea,select,[contenteditable="true"]'));
}

export type FluActionOutcome='navigated'|'paused'|'blocked-form'|'stale'|'offered'|'guided'|'unavailable';
export function fluDestinationLabel(path:string){
 const labels:Record<string,string>={'/dashboard':'la dashboard','/leads':'le richieste','/calendar':'il calendario','/deals':'le offerte','/newsletter':'le newsletter','/settings?tab=users':'gli utenti','/settings?tab=lead-pipelines':'le pipeline'};
 return (path.startsWith('/calendar?')&&parseCalendarActivityTarget(path.slice(path.indexOf('?')))?'il giorno dell’attività':null)||labels[path]||(path.startsWith('/deals/')&&uuid.test(path.slice(7))?'la scheda dell’offerta':null)||(path.startsWith('/projects/')&&fluProjectPath(path.slice(10))===path?'il progetto collegato':null)||(path.startsWith('/leads/')&&fluRecordPath(path.slice(7))===path?'la scheda collegata':null);
}
export function fluNavigationMessage(action:string|null,outcome:FluActionOutcome){
 if(!action||outcome==='guided'||outcome==='unavailable')return null;
 const resolved=Object.hasOwn(fluSectionPaths,action)?action:parentFluAction(action);
 if(!resolved)return null;
 const label=fluDestinationLabel(fluSectionPaths[resolved]);if(!label)return null;
 if(outcome==='navigated')return 'Ti accompagno nel CRM: apro '+label+'.';
 if(outcome==='paused')return 'La navigazione automatica è in pausa. Puoi aprire '+label+' dal pulsante, quando preferisci.';
 if(outcome==='blocked-form')return 'Hai un modulo aperto nel CRM. Prima salvalo o chiudilo, poi possiamo aprire '+label+'.';
 if(outcome==='stale')return 'La schermata è cambiata mentre rispondevo: resto dove sei. Dimmi se vuoi ancora aprire '+label+'.';
 return 'Puoi aprire '+label+' dal pulsante, quando preferisci.';
}
export function fluNavigationNote(path:string,phase:'requested'|'arrived'|'unconfirmed'){
 const label=fluDestinationLabel(path);if(!label)return '';
 if(phase==='requested')return 'Apro '+label+' nel CRM…';
 if(phase==='arrived')return 'Sei nel CRM: '+label+'. Le modifiche richiedono la tua conferma.';
 return 'Non ho confermato l’apertura di '+label+'. Controlla la schermata o riprova dal pulsante.';
}
